import { Inject, Injectable } from '@angular/core';
import { ClientMetadata } from '../config/typings/models';
import { IAppSettingsService } from '../config/typings/services';
import { WINDOW } from '../window/WindowService';

// Returns the metadata provided by the server and methods for
// accessing local storage.
@Injectable({
    providedIn: 'root'
})
export class AppSettingsService implements IAppSettingsService {
    public static $name: string = 'appSettingsService';

    constructor(
        @Inject(WINDOW) private window: Window
    ) {
    }

    public getMetadata(): ClientMetadata {
        let globalApp = this.window['App'];

        if (globalApp) {
            return globalApp.metadata;
        }

        return {};
    }
}
